import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { apiSlice } from "../slices/api/apiSlice";
import appReducer from "../slices/sync/appSlice";
import authReducer from "../slices/sync/authSlice";
import userReducer from "../slices/sync/userSlice";
import fcmReducer from "../slices/sync/fcmSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "user"], // persist
};

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  user: userReducer,
  fcm: fcmReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});


export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
